module.exports = __webpack_public_path__ + "img/audio-permission-setting-firefox.9e401fdd.gif";